import { Container } from 'pixi.js';
import { getLocalizedValue } from '@softgames/localization';
import type { BlockerView } from '../../types';
import { CoinBlockerLayout } from '../../../../../layouts/blockers/CoinBlockerLayout';
import type { CoinBlockerModel } from '../../models/blockers/CoinBlockerModel';
//import { centerElements } from '../../../utils/centerElements';
import { playLayoutAnimation } from '../../../../libs/layouts/layoutAnimations/playLayoutAnimation';

export class CoinBlockerView extends Container implements BlockerView {
  private readonly layout = new CoinBlockerLayout();

  constructor(private readonly model: CoinBlockerModel) {
    super();

    const { root, coinAmount } = this.layout;

    root.props({
      parent: this,
    });

    coinAmount.text = getLocalizedValue(model.getPrice());

    void playLayoutAnimation(this.layout, 'Idle', true);
    //centerElements(this.layout.center_SPL, -5);
  }

  public getModel(): CoinBlockerModel {
    return this.model;
  }

  public async animateRemoval(): Promise<void> {
    await playLayoutAnimation(this.layout, 'Unlock');

    this.destroy({ children: true });
  }
}
